import { Box, Stack } from "@mui/material";
import {
  ExistingFileTypes,
  WorkflowType,
  SettingsResponsePC,
  SettingsResponseReflection,
} from "@pages/data-management/data-management-types";
import { ProcessOptions } from "@pages/data-management/process-options";
import { PublishOptions } from "@pages/data-management/publish-options";
import { isDevModeEnabledSelector } from "@store/app/app-selector";
import { useAppSelector } from "@store/store-helper";

interface Props {
  /** Type of the workflow, automatic or manual. */
  workflowType: WorkflowType,
  /** Flags for the occurring file types, incl. some combined meta information like hasLsDataV2. */
  existingFileTypes: ExistingFileTypes,
  /** Settings object received by getPublishSettings. */
  settingPC: SettingsResponsePC,
  /** Callback to set new value of settingPC. */
  setSettingPC: (value: React.SetStateAction<SettingsResponsePC>) => void,
  /** Settings object received by getPublishSettings. */
  settingReflection: SettingsResponseReflection,
  /** Callback to set new value of settingReflection. */
  setSettingReflection: (value: React.SetStateAction<SettingsResponseReflection>) => void,
}

/** Processing and publication options for the selected scans. */
export function OptionsComponent({
  workflowType,
  existingFileTypes,
  settingPC,
  setSettingPC,
  settingReflection,
  setSettingReflection,
}: Props): JSX.Element {
  const isDevModeEnabled = useAppSelector(isDevModeEnabledSelector);
  // Currently only Orbis scans have processing options.
  // Currently none of the Orbis processing options can actually be set.
  const hasProcessingOptions = existingFileTypes.hasOrbis && isDevModeEnabled;

  return (
    <Stack>
      <Box sx={{
        ml: "27px",
        textTransform: "uppercase",
        fontSize: "14px",
        fontWeight: "700",
      }}>
        Settings
      </Box>

      { hasProcessingOptions && (
        <Box sx={{ mt: "20px" }}>
          <ProcessOptions existingFileTypes={existingFileTypes}/>
        </Box>
      )}

      <Box sx={{ mt: hasProcessingOptions ? "40px" : "20px" }}>
        <PublishOptions
          workflowType={workflowType}
          settingPC={settingPC}
          setSettingPC={setSettingPC}
          settingReflection={settingReflection}
          setSettingReflection={setSettingReflection}
        />
      </Box>
    </Stack>
  );
}
